module.exports = __webpack_public_path__ + "static/media/kano-govt.02700b25.png";